// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"f01edbef","41":"6c335987","623":"0add2115","674":"025b9ece","751":"6eee6087","978":"5461ce4c"}[chunkId] + ".chunk.css";
};